import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import { TweenMax, Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default function company(){
  if(document.getElementById('history')){

    const historySlides = document.getElementById('historySlides');
    if(historySlides){
      new Swiper(historySlides, {
        slidesPerView: '1',
        spaceBetween: 20,
        loop: true,
        speed: 400,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    }

    gsap.fromTo(
      '.history__list__line',
      {
        height: 0,
      },
      {
        height: '100%',
        scrollTrigger: {
          ease: Power2.easeIn,
          trigger: '.history__list',
          start: "top center",
          end: "bottom center",
          scrub: true,
          //markers: true
        },
      }
    )

    gsap.utils.toArray('.history__list li').forEach((item) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 80%',
        end: 'top 15%',

        onEnter: () => {
          item.classList.add('active');
        },

        /*
        onLeave: () => {
          item.classList.remove('active');
        },
        
        onEnterBack: () => {
          item.classList.add('active');
        },

        onLeaveBack: () => {
          item.classList.remove('active');
        },
        */
        // markers: true,
      });
    });

  }
}
